import React from 'react';
import { motion } from 'framer-motion';
import { Box, Container, Typography, Button } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';

export default function HeroSection() {
  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        pt: { xs: 10, md: 12 },
        pb: { xs: 10, md: 12 },
        overflow: 'hidden',
        backgroundImage: 'url(https://images.unsplash.com/photo-1544717297-fa95b6ee9643?w=1920&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: 'rgba(30, 91, 92, 0.9)',
          zIndex: 1
        }
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
        <Box sx={{ maxWidth: '48rem' }}>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Typography
              variant="h2"
              component="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '4rem' },
                fontWeight: 'bold',
                color: 'white',
                mb: 6,
                lineHeight: 1.2,
                mt: 5
              }}
            >
              Expert Consultant in Taxation and Business Loan
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mt: 10 }}>
              <Button
                variant="contained"
                size="large"
                onClick={() => {
                  document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                  window.history.pushState({}, '', '/contact');
                }}
                endIcon={<ChevronRight />}
                sx={{
                  bgcolor: 'white',
                  color: 'rgba(30, 91, 92, 1)',
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.9)' },
                  py: 1.5,
                  px: 3
                }}
              >
                Get Consultation
              </Button>
              <Button
                variant="outlined"
                size="large"
                onClick={() => {
                  document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
                  window.history.pushState({}, '', '/services');
                }}
                sx={{
                  borderColor: 'white',
                  color: 'white',
                  '&:hover': { bgcolor: 'rgba(255,255,255,0.1)', borderColor: 'white' },
                  py: 1.5,
                  px: 3
                }}
              >
                Our Services
              </Button>
            </Box>
          </motion.div>
        </Box>
      </Container>
    </Box>
  );
}